module.exports = __webpack_public_path__ + "img/firebase.10b07193.svg";